import React, { useContext } from 'react'
import { Formik, Form as FormikForm } from 'formik'

import { Button } from '@components/Button'
import { InputFieldWithLabel } from '@components/Form/Fields'
import { Grid } from '@components/layout/Grid'

import {
  setupValidationSchema,
  initialCredentialsFormValues,
} from './validations'
import { AstuteContext } from '../../context'

export const Form = () => {
  const {
    state: { astuteCredentials },
    actions: { navigateToIndex, submitAstuteCredentialsForm },
  } = useContext(AstuteContext)

  const handleSubmit = (values) => submitAstuteCredentialsForm(values, () => null)

  return (
    <>
      <InfoContent />
      <Formik
        validateOnChange
        onSubmit={handleSubmit}
        validationSchema={setupValidationSchema()}
        initialValues={initialCredentialsFormValues({
          username: astuteCredentials && astuteCredentials.username
        })}
        render={(formProps) => (
          <Grid className='app-form quote-form'>
            <FormFields
              formProps={formProps}
              navigateToIndex={navigateToIndex}
              astuteCredentials={astuteCredentials}
            />
          </Grid>
        )}
      />
    </>
  )
}

const FormFields = ({ astuteCredentials, formProps, navigateToIndex }) => (
  <FormikForm>
    <InputFieldWithLabel label='Username' name='username' />
    <InputFieldWithLabel label='Password' name='password' type='password' />
    <InputFieldWithLabel label='Confirm password' name='passwordConfirmation' type='password' />
    <div className='flex flex-end' style={{gap: '1rem'}}>
      { astuteCredentials && astuteCredentials.id && (
        <Button
          secondary
          className='button'
          onClick={navigateToIndex}
          disabled={formProps.isSubmitting}
        >
          Back
        </Button>
      )}

      <Button
        primary
        type='submit'
        trackAs='Astute: Credentials set'
        disabled={!formProps.isValid || formProps.isSubmitting}
      >
        {formProps.isSubmitting ? 'Saving...' : 'Save'}
      </Button>
    </div>
  </FormikForm>
)

const InfoContent = () => (
  <section className='info-section'>
    <p>
      Add your Astute Credentials in order to retrieve client asset data from
      your Astute account
    </p>
  </section>
)
